var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.93 19.3201C14.74 19.3201 14.55 19.2501 14.4 19.1001C14.11 18.8101 14.11 18.3301 14.4 18.0401L19.94 12.5001L14.4 6.96012C14.11 6.67012 14.11 6.19012 14.4 5.90012C14.69 5.61012 15.17 5.61012 15.46 5.90012L21.53 11.9701C21.82 12.2601 21.82 12.7401 21.53 13.0301L15.46 19.1001C15.31 19.2501 15.12 19.3201 14.93 19.3201Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.83 13.25H4C3.59 13.25 3.25 12.91 3.25 12.5C3.25 12.09 3.59 11.75 4 11.75H20.83C21.24 11.75 21.58 12.09 21.58 12.5C21.58 12.91 21.24 13.25 20.83 13.25Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.b890c07a4e098d9cf6f45c98c7bb0979.svg";
export { ForwardRef as ReactComponent };